module.exports = {"pageTitle":"공지사항","version":"버전","event":"이벤트","checking":"확인중","operator":"운영자","notEntered":"미입력","dateNotEntered":"날짜:미입력","target":"대상","views":"조회수","status":"상태","editButton":"수정하기","active":"활성화","inactive":"비활성화","golfClubCount":"골프클럽({n})","replyAlert1":"답변을 등록하면 문의자에게","replyAlert2":"알림이 발송됩니다.","replyAlert3":"이대로 등록하시겠습니까?"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/cs002.json
// module id = 2ghZ
// module chunks = 2